"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _renderProps = require("../../../libs/renderProps");

var _SearchBox = _interopRequireDefault(require("../../../preact-components/search-box/SearchBox"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchableFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchableFilterSelector, _Component);

  var _super = _createSuper(SearchableFilterSelector);

  function SearchableFilterSelector(props) {
    var _this$props$items;

    var _this;

    (0, _classCallCheck2.default)(this, SearchableFilterSelector);
    _this = _super.call(this, props);
    _this.state = {
      value: '',
      filteredItems: (_this$props$items = _this.props.items) !== null && _this$props$items !== void 0 ? _this$props$items : []
    };
    _this.onInputHandler = _this.onInputHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClearHandler = _this.onClearHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SearchableFilterSelector, [{
    key: "onInputHandler",
    value: function onInputHandler(e) {
      var _this$props$items$fil,
          _this$props$items2,
          _this2 = this;

      var target = e.target;
      this.setState({
        value: target.value,
        filteredItems: (_this$props$items$fil = (_this$props$items2 = this.props.items) === null || _this$props$items2 === void 0 ? void 0 : _this$props$items2.filter(function (item) {
          return item.name.toLowerCase().includes(target.value.toLowerCase());
        })) !== null && _this$props$items$fil !== void 0 ? _this$props$items$fil : []
      }, function () {
        var _this2$props$handleSe, _this2$props;

        return (_this2$props$handleSe = (_this2$props = _this2.props).handleSearchInputChange) === null || _this2$props$handleSe === void 0 ? void 0 : _this2$props$handleSe.call(_this2$props, _this2.state.filteredItems);
      });
    }
  }, {
    key: "onClearHandler",
    value: function onClearHandler() {
      var _this$props$items3,
          _this3 = this;

      // this.props.onClickClear?.()
      this.setState({
        value: '',
        filteredItems: (_this$props$items3 = this.props.items) !== null && _this$props$items3 !== void 0 ? _this$props$items3 : []
      }, function () {
        var _this3$props$handleSe, _this3$props;

        return (_this3$props$handleSe = (_this3$props = _this3.props).handleSearchInputChange) === null || _this3$props$handleSe === void 0 ? void 0 : _this3$props$handleSe.call(_this3$props, _this3.state.filteredItems);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          children = _this$props.children,
          onClickSelectAll = _this$props.onClickSelectAll,
          selectionLabel = _this$props.selectionLabel;
      var _this$state = this.state,
          value = _this$state.value,
          filteredItems = _this$state.filteredItems;
      return (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: placeholder,
        value: value,
        onSubmit: function onSubmit() {},
        onInput: this.onInputHandler,
        onClear: this.onClearHandler
      }), filteredItems.length === 0 && (0, _preact.h)("div", {
        className: "overview__filters-box-content-no-results"
      }, "No results found"), filteredItems.length > 0 && (0, _preact.h)("p", {
        className: "select-all",
        onClick: function onClick() {
          return onClickSelectAll === null || onClickSelectAll === void 0 ? void 0 : onClickSelectAll(filteredItems);
        }
      }, selectionLabel), (0, _renderProps.extractRenderPropsChildren)(children)({
        items: filteredItems,
        value: value
      }));
    }
  }]);
  return SearchableFilterSelector;
}(_preact.Component);

var _default = SearchableFilterSelector;
exports.default = _default;